module.exports = __webpack_public_path__ + "static/media/02.cacbe96a.jpg";